
import api from '~api'
import setting from '../../server/settings'
import wx from 'weixin-js-sdk'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

var sha1 = require('sha1');
export default {
name: "uploadPic",
components: {
XHeader,Group,Selector,XInput,Toast,Confirm
},
data() {
return {
baseurl: setting.api_root+ '/api/greenchannel/imgLook?params=',
title: "照片上传",
stuinfo:{},
showtoast:false,
toasttext:'',
imgUrl:'',
show:false,
}
},
mounted(){
this.getStuInfo();
this.wxconfig();
},
methods:{
getStuInfo(){
api.post("/api/NewReports/findInformation",{"stuCode": this.$route.params.stunum}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if( this.stuinfo.newPhotoPath){
this.imgUrl = ""
}
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
},
backPage(){
this.$router.push({name:'home'})
},
sortParam(obj){
var paramArr = [];
for(var o in obj){
paramArr.push(o +"="+ obj[o] +"&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},
wxconfig(){
const _this = this;
const arr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
let idvalue ='';
const n = 16;
for(var i=0;i<n;i++){
idvalue += arr[Math.floor(Math.random()*26)];
}
let time = ((new Date()).valueOf().toString()).slice(0,10);
time = Number(time)
api.post('/api/wx/getTicket').then(function (response) {
if(response.status == 200){
var params = {
"timestamp": time,
"jsapi_ticket": response.data.data,
"noncestr":idvalue,
"url":(window.location.href).split('#')[0]
};
const sortParam = (_this.sortParam(params)).slice(0,_this.sortParam(params).length-1)
const sign = sha1(sortParam);

wx.config({
debug: false, // 开启调试模式,
appId: setting.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
timestamp: time, // 必填，生成签名的时间戳
nonceStr: idvalue, // 必填，生成签名的随机串
signature: sign,// 必填，签名，见附录1
jsApiList: ['checkJsApi','getLocalImgData','chooseImage'] 
});
wx.error(function(res){
alert(JSON.stringify(res))
});
}
})
},
chooesPic(){
if(this.stuinfo.newPhotoPath){
return;
}
const _this = this;
wx.checkJsApi({  //判断当前客户端版本是否支持指定JS接口
jsApiList: ['getLocalImgData','chooseImage'],
success: function (res) {// 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
if(res.checkResult.getLocalImgData != true){
alert('抱歉，当前客户端版本不支持本地选择图片');
}else {
wx.chooseImage({
count: 1, //张数， 默认9
sizeType: ["compressed"], //建议压缩图
sourceType: ["album"], // 来源是相册、相机
success: function (res) {
wx.getLocalImgData({
localId: res.localIds[0], // 图片的localID
success: function (res) {
var localData = res.localData; 
if(localData.startsWith("data:image")){
_this.imgUrl = localData;
}else{
_this.imgUrl = "data:image/png;base64," + localData;
}
}
});
},
error: function(res){
alert('版本过低请升级')
}
});

}
},
fail: function (res) { //检测getNetworkType该功能失败时处理
alert('checkJsApi error');
}
});
},
changeCheck(){

if(this.imgUrl === ''){
this.$msgbox('温馨提示：',"请选择修改照片！");
return false
}else{
return true
}
},
uploadPicture(){
if(this.changeCheck()){
this.$vux.loading.show({
text: '上传中，请稍候！'
})
var param = {
'stuCode': this.stuinfo.stuCode,
'base64Photo': this.imgUrl,
};
api.post("/stuphoto/verifyStuPhoto", param).then( res=>{
if(res.status==200){
if(res.data.code=='0'){
this.getStuInfo()
this.$msgbox('温馨提示：',"照片上传成功！");
}else{
this.$msgbox('温馨提示：',res.data.results);
}
}
this.$vux.loading.hide()
})
}
},
}
}



// WEBPACK FOOTER //
// ./src/components/uploadPic.vue